import React from "react";
import { useTranslation } from "react-i18next";
import get from "lodash/get";
import set from "@rill/set";
import submit from "submit-form";
import getAvatarUrl from "../../../utils/get-avatar-url";
import SettingsNav from "../../../parts/settings-nav";
import ConfirmRemoveCoach from "../../../parts/modals/confirm-remove-coach";
import Avatar from "../../../parts/avatar";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import { useRillContext } from "../../../rill/RillReact/share/base";

function View(props) {
  const { t } = useTranslation(["dashboard", "common"]);
  const { locals } = useRillContext();

  const {
    activeUser,
    coach,
    countries: countryOptions,
    units,
    momentTZ,
  } = locals;
  if (!coach) return null;

  return (
    <main className="settings manage-coaching ">
      <SettingsNav />

      <section>
        <h3>{t("manageCoaching.title")}</h3>
        <div className="frame">
          {coach && <label className="mb-2">{t("manageCoaching.yourCoach")}</label>}
          <div className="flex gap-2 items-center">
            <Avatar size={120} url={getAvatarUrl(coach)} className={"image"} />

            <div className="ml-2">
              <h4>{coach.name}</h4>
              {!coach && <p>{t("manageCoaching.hasRequestedToBeYourCoach")}</p>}
            </div>

            <div className="ml-auto">
              {activeUser.coach && (
                <a
                  href={`/dashboard/settings/manage-coaching/?modal[type]=confirm-remove-coach`}
                  role="button"
                  data-button-type="secondary"
                  data-action="cancel"
                >
                  {t("common:remove")}
                </a>
              )}
              {!activeUser.coach && (
                <button
                  onClick={(e) => manageCoach(e, "accept")}
                  data-button-type="primary"
                  type="submit"
                >
                  {t("manageCoaching.accept")}
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="chip info">
          <div>
            <p>{t("manageCoaching.whatDoesThisMean")}</p>
            <ul>
              <li>
                {t("manageCoaching.bulletAddPrograms")}
              </li>
              <li>
                {t("manageCoaching.bulletViewCalendar")}
              </li>
              <li>{t("manageCoaching.bulletViewMetrics")}</li>
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
}

function manageCoach(e, actionToPerform) {
  submit("/dashboard/settings/manage-coaching", {
    method: "POST",
    body: {
      actionToPerform,
    },
  });
}

const ManageCoaching = (app) => {
  app
    .get(
      "/manage-coaching",
      set("heading", "Manage Coach"),
      async ({ req, load, locals, res, api, flash, assert, momentTZ }) => {
        const { activeUser, query } = locals;
        const coach =
          activeUser.coach || get(activeUser, "coachingInvite.coach");
        // Redirect to profile if user has no coach
        if (!coach) return res.redirect("/dashboard/settings/profile");
        const modal = get(query, "modal", {});

        // loads the coach user
        await load("profileUser", { user: coach._id });
        locals.coach = Object.assign({}, coach, locals.profileUser);
        locals.modal = {
          "confirm-remove-coach": <ConfirmRemoveCoach />,
          "activity-feed": <ActivityDrawer />,
        }[modal.type];

        res.body = <View />;
      }
    )
    .post(
      "/manage-coaching",
      async ({ req, locals, res, api, flash, assert, momentTZ }) => {
        const activeUser = locals.activeUser;
        const { body } = req;

        await api("manage-coaching", { method: "PUT", body });
        flash(
          "success",
          `Coach ${
            body.actionToPerform == "accept" ? "accepted" : "removed"
          } successfully.`
        );

        if (body.actionToPerform === "accept") return res.backDontScroll();
        return res.redirect("/dashboard/settings/profile");
      }
    );
};

export default ManageCoaching;
